/* ===== merged from custom.js — kept first to preserve prior load order ===== */

/* slide animation helpers (height-based slideUp / slideDown / slideToggle) */
function slideUp(el, duration) {
  duration = duration === undefined ? 300 : duration;
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight; // force reflow
  el.style.overflow = 'hidden';
  el.style.transition = 'height ' + duration + 'ms ease, padding ' + duration + 'ms ease, margin ' + duration + 'ms ease';
  el.style.height = '0';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  window.setTimeout(function () {
    el.style.display = 'none';
    ['height', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom', 'overflow', 'transition'].forEach(function (p) {
      el.style.removeProperty(p);
    });
  }, duration);
}

function slideDown(el, duration) {
  duration = duration === undefined ? 300 : duration;
  el.style.removeProperty('display');
  var display = window.getComputedStyle(el).display;
  if (display === 'none') display = 'block';
  el.style.display = display;
  var height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = '0';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  el.offsetHeight; // force reflow
  el.style.transition = 'height ' + duration + 'ms ease, padding ' + duration + 'ms ease, margin ' + duration + 'ms ease';
  ['padding-top', 'padding-bottom', 'margin-top', 'margin-bottom'].forEach(function (p) {
    el.style.removeProperty(p);
  });
  el.style.height = height + 'px';
  window.setTimeout(function () {
    ['height', 'overflow', 'transition'].forEach(function (p) {
      el.style.removeProperty(p);
    });
  }, duration);
}

function slideToggle(el, duration) {
  if (window.getComputedStyle(el).display === 'none') {
    slideDown(el, duration);
  } else {
    slideUp(el, duration);
  }
}

document.addEventListener('DOMContentLoaded', function () {

  var stickyAddBtn = document.getElementById('sticky-add-to-cart');
  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', function () {
      var buyButtons = document.querySelector('.product-form');
      if (!buyButtons) return;
      var header = document.querySelector('.shopify-section-header-sticky');
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var targetOffset = buyButtons.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: targetOffset - headerHeight, behavior: 'smooth' });
    });
  }

  var mediaSection = document.querySelector('.product__media-wrapper');
  var productInfoWrapper = document.querySelector('.product__info-wrapper');
  var productOuter = document.querySelector('.product__outer');
  var activeClass = 'active';
  var cachedMediaTop = 0;
  var cachedMediaBottom = 0;

  function updateProductOuterHeight() {
    if (!mediaSection) return;
    var totalHeight = 0;
    mediaSection.querySelectorAll('.swiper-slide img').forEach(function (img) {
      var h = img.getBoundingClientRect().height;
      if (h > 0) totalHeight += h;
    });
    if (totalHeight > 0 && productOuter) {
      productOuter.style.minHeight = totalHeight + 'px';
    }
  }

  function cacheMediaBounds() {
    if (mediaSection) {
      var rect = mediaSection.getBoundingClientRect();
      cachedMediaTop = rect.top + window.scrollY;
      cachedMediaBottom = cachedMediaTop + rect.height;
    }
  }

  if (window.innerWidth >= 991) {
    updateProductOuterHeight();
    cacheMediaBounds();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth >= 991) {
        updateProductOuterHeight();
        cacheMediaBounds();
      }
    }, 150);
  });

  if (mediaSection) {
    mediaSection.querySelectorAll('.swiper-slide img').forEach(function (img) {
      img.addEventListener('load', function () {
        if (window.innerWidth >= 991) {
          updateProductOuterHeight();
          cacheMediaBounds();
        }
      });
    });
  }

  var mediaStickyPending = false;
  window.addEventListener('scroll', function () {
    if (mediaStickyPending) return;
    mediaStickyPending = true;
    requestAnimationFrame(function () {
      mediaStickyPending = false;
      if (window.innerWidth < 991 || !mediaSection) return;

      var scrollTop = window.scrollY;
      var windowHeight = window.innerHeight;

      if (scrollTop + windowHeight > cachedMediaTop && scrollTop < cachedMediaBottom) {
        if (productInfoWrapper && !productInfoWrapper.classList.contains(activeClass)) {
          productInfoWrapper.classList.add(activeClass);
        }
        if (productInfoWrapper) productInfoWrapper.style.top = '20px';
        mediaSection.style.top = '20px';
      } else {
        if (productInfoWrapper && productInfoWrapper.classList.contains(activeClass)) {
          productInfoWrapper.classList.remove(activeClass);
        }
        if (productInfoWrapper) productInfoWrapper.style.top = '';
        mediaSection.style.top = '';
      }
    });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.js-add-to-bag');
    if (!trigger) return;
    event.preventDefault();

    var cardWrapper = trigger.closest('.card-wrapper, .product-card');
    if (!cardWrapper) return;

    var getVariantId = cardWrapper.getAttribute('data-variant-id');
    if (!getVariantId) {
      var pfInput = cardWrapper.querySelector('.product-form input[name="id"]');
      getVariantId = pfInput && pfInput.value;
    }
    if (!getVariantId) {
      var anyInput = cardWrapper.querySelector('input[name="id"]');
      getVariantId = anyInput && anyInput.value;
    }

    if (!getVariantId) return;

    var formData = new FormData();
    formData.append('id', getVariantId);
    formData.append('sections', ['cart-drawer', 'cart-icon-bubble']);
    formData.append('sections_url', window.location.pathname);

    setButtonLoading(trigger, true);
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
    .then(function (res) { return res.json(); })
    .then(function (response) {
      setButtonLoading(trigger, false);
      if (response.status) return;
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl) {
        cartDrawerEl.renderContents(response);
      }
    })
    .catch(function () { setButtonLoading(trigger, false); });
  });

  var swiperWrapper = document.querySelector('.js-swiper-product-recommendations .swiper-wrapper');
  if (swiperWrapper && swiperWrapper.children.length === 0) {
    var recObserver = new MutationObserver(function (mutations, obs) {
      if (swiperWrapper.children.length > 0) {
        obs.disconnect();
      }
    });
    recObserver.observe(swiperWrapper, { childList: true });
  }

  var checkoutForm = document.querySelector('.checkout-form');
  var stickyAddToCart = document.getElementById('fixed-sticky-bar');
  var lastScrollPosition = window.scrollY;
  var stickyVisible = false;
  var atcPending = false;

  function isFullyOutOfViewport(element) {
    return element.getBoundingClientRect().bottom < 0;
  }

  function isScrollingDown() {
    var current = window.scrollY;
    var down = current > lastScrollPosition;
    lastScrollPosition = current;
    return down;
  }

  function toggleStickyAddToCart() {
    if (!checkoutForm || !stickyAddToCart) return;
    if (isFullyOutOfViewport(checkoutForm)) {
      if (isScrollingDown() || stickyVisible) {
        stickyAddToCart.style.display = 'block';
        stickyVisible = true;
      }
    } else {
      stickyAddToCart.style.display = 'none';
      stickyVisible = false;
    }
  }

  window.addEventListener('scroll', function () {
    if (atcPending) return;
    atcPending = true;
    requestAnimationFrame(function () {
      atcPending = false;
      toggleStickyAddToCart();
    });
  });

  var atcResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(atcResizeTimer);
    atcResizeTimer = setTimeout(toggleStickyAddToCart, 150);
  });

  toggleStickyAddToCart();

});

/* ===== main.js ===== */
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.story__toggle').forEach(function (plus) {
    plus.addEventListener('click', function () {
      var currentStory = plus.closest('.story__card');
      document.querySelectorAll('.story__card').forEach(function (el) {
        el.classList.remove('story__card--active');
      });
      if (currentStory) currentStory.classList.add('story__card--active');
      document.querySelectorAll('.story__card-bottom .story__details--open').forEach(function (el) {
        el.classList.remove('story__details--open');
        el.classList.add('story__details--closed');
      });
      var targetStory = Array.prototype.filter.call(plus.parentNode.children, function (sib) {
        return sib !== plus && sib.classList.contains('story__details--closed');
      });
      setTimeout(function () {
        targetStory.forEach(function (el) {
          el.classList.remove('story__details--closed');
          el.classList.add('story__details--open');
        });
      }, 450);
    });
  });

  var coinEl = document.querySelector('.coin-carousel');
  if (coinEl) {
    var sec5 = coinEl.closest('.bundle-pricing');
    // eslint-disable-next-line no-new
    new Swiper(coinEl, {
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      speed: 700,
      spaceBetween: 0,
      navigation: {
        nextEl: sec5 ? sec5.querySelector('.coin-carousel__arrow--next') : '.coin-carousel__arrow--next',
        prevEl: sec5 ? sec5.querySelector('.coin-carousel__arrow--prev') : '.coin-carousel__arrow--prev'
      }
    });
  }

  document.querySelectorAll('.footer__accordion').forEach(function (acc) {
    acc.addEventListener('click', function () {
      var links = acc.nextElementSibling;
      if (links && links.classList.contains('footer__links')) {
        slideToggle(links);
      }
      var parent = acc.parentNode;
      if (parent && parent.parentNode) {
        Array.prototype.forEach.call(parent.parentNode.children, function (sib) {
          if (sib !== parent) {
            sib.querySelectorAll('.footer__links').forEach(function (l) { slideUp(l); });
          }
        });
      }
    });
  });

});

/* ============================================================
   Button processing state — reusable, subtle, CSS-driven.
   setButtonLoading(btn, true) swaps the label for a spinner in the button's
   own text colour while preserving its size (no layout shift); ...false
   restores it. Exposed as window.setButtonLoading for other components.
   ============================================================ */
function setButtonLoading(btn, on) {
  if (!btn) return;
  if (on) {
    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';
    var rect = btn.getBoundingClientRect();
    btn.style.minWidth = Math.ceil(rect.width) + 'px';
    btn.style.minHeight = Math.ceil(rect.height) + 'px';
    btn.dataset.loadingLabel = btn.innerHTML;
    if (!btn.hasAttribute('aria-label')) {
      btn.dataset.loadingSetLabel = '1';
      btn.setAttribute('aria-label', (btn.textContent || '').trim());
    }
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.innerHTML = '<span class="btn-spinner" aria-hidden="true"></span>';
  } else {
    if (btn.dataset.loading !== '1') return;
    delete btn.dataset.loading;
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    if ('loadingLabel' in btn.dataset) { btn.innerHTML = btn.dataset.loadingLabel; delete btn.dataset.loadingLabel; }
    if (btn.dataset.loadingSetLabel) { btn.removeAttribute('aria-label'); delete btn.dataset.loadingSetLabel; }
    btn.style.minWidth = '';
    btn.style.minHeight = '';
  }
}
window.setButtonLoading = setButtonLoading;

/* ============================================================
   Gentle image fade-in. SEO-safe: the real src + loading="lazy" stay in the
   markup (browser defers the fetch until near the viewport); we only fade the
   image in once it has actually loaded. No-JS safe: the dimming class is added
   by JS, so without JS the images are simply visible.
   ============================================================ */
function fadeInImages(root) {
  var scope = root || document;
  // once every js-fade image in a .lazy-host has loaded, fade out its blurred
  // preview (the host's ::before)
  var settleHost = function (img) {
    var host = img.closest && img.closest('.lazy-host');
    if (!host) return;
    var all = host.querySelectorAll('img.js-fade');
    var ready = Array.prototype.every.call(all, function (x) {
      return x.classList.contains('is-loaded') || (x.complete && x.naturalWidth);
    });
    if (ready) host.classList.add('is-loaded');
  };
  var imgs = scope.querySelectorAll('img.js-fade');
  Array.prototype.forEach.call(imgs, function (img) {
    if (img.dataset.fadeBound) return;
    img.dataset.fadeBound = '1';
    if (img.complete && img.naturalWidth) { settleHost(img); return; }   // cached — leave visible
    img.classList.add('is-loading');
    var done = function () { img.classList.remove('is-loading'); img.classList.add('is-loaded'); settleHost(img); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  });
}
window.fadeInImages = fadeInImages;
document.addEventListener('DOMContentLoaded', function () { fadeInImages(); });

/* ============================================================
   Background blur-up. An element with a CSS background-image + data-bg-full
   shows a blurred tiny preview (its ::after, fed by --bg-lqip) until the full
   background image finishes loading, then crossfades to it. We detect the
   load by preloading the same URL (cached — it's the same request the
   background fires). SEO-safe: nothing about the markup/URLs changes.
   ============================================================ */
function blurUpBackgrounds(root) {
  var els = (root || document).querySelectorAll('[data-bg-full]');
  Array.prototype.forEach.call(els, function (el) {
    if (el.dataset.bgBound) return;
    el.dataset.bgBound = '1';
    var src = el.getAttribute('data-bg-full');
    if (!src) { el.classList.add('bg-loaded'); return; }
    var im = new Image();
    im.onload = im.onerror = function () { el.classList.add('bg-loaded'); };
    im.src = src;
    if (im.complete) el.classList.add('bg-loaded');
  });
}
window.blurUpBackgrounds = blurUpBackgrounds;
document.addEventListener('DOMContentLoaded', function () { blurUpBackgrounds(); });

function addToCartAndCheckout(event) {
  event.preventDefault();
  var btn = event.currentTarget || (event.target && event.target.closest('button'));
  var form = event.target.closest('form');
  var formData = new FormData(form);
  setButtonLoading(btn, true);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(function (response) {
    if (!response.ok) throw new Error('Failed to add product to cart');
    return response.json();
  })
  .then(function () {
    window.location.href = '/checkout';   // keep the spinner until the page navigates
  })
  .catch(function () { setButtonLoading(btn, false); });
}

/* ============================================================
   main-product variant/gallery sync (was product-page.js)
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {
  // Wait just 500ms for Swiper to initialize natively, instead of 5 seconds
  setTimeout(function () {

    // --- HELPER 1: UPDATE TEXT/IMAGE BLOCKS ---
    function updateAssociatedBlocks(container, variantId) {
      if (!container || !variantId) return;
      
      container.querySelectorAll(".variant-specs").forEach(function (spec) {
        spec.style.display = (spec.getAttribute("data-variant-id") === variantId) ? "block" : "none";
      });
      container.querySelectorAll(".product-symbols__variant").forEach(function (smbImg) {
        smbImg.style.display = (smbImg.getAttribute("data-variant-id") === variantId) ? "block" : "none";
      });
    }

    // --- HELPER 2: UPDATE SWIPER GALLERY ---
    function updateProductGallery(container, imgUrl) {
      if (!imgUrl || !container) return;
      
      // Clean Shopify URL parameters safely
      var rawPath = imgUrl.split('?')[0].split('&')[0]; 
      var baseFileName = rawPath.split('/').pop().replace(/_[0-9]+x[0-9]*[a-zA-Z]*\./, '.').split('.')[0];

      var targetImg = container.querySelector('.js-media-list img[src*="' + baseFileName + '"]') || 
                      container.querySelector('.product-gallery__media img[src*="' + baseFileName + '"]');
      
      if (targetImg) {
        var parentItem = targetImg.closest('.product__media-item');
        if (parentItem) {
          var fullMediaId = parentItem.getAttribute('data-media-id');
          
          // Helper to toggle slides for a given swiper container
          var toggleSlides = function(selector, idAttribute) {
            var items = container.querySelectorAll(selector);
            var isCurrentGroup = false;
            
            items.forEach(function(media, idx) {
              if (media.classList.contains('product__media-item--variant') || idx === 0) {
                isCurrentGroup = (media.getAttribute(idAttribute) === fullMediaId);
              }
              media.style.display = isCurrentGroup ? '' : 'none';
              media.classList.toggle('swiper-slide', isCurrentGroup);
            });
          };

          toggleSlides('.js-media-list .product__media-item', 'data-media-id');
          toggleSlides('.js-media-sublist .product__media-subitem', 'data-media-sub-id');

          // Update Swipers
          ['.js-media-list', '.js-media-sublist'].forEach(function(selector) {
            var swiperEl = container.querySelector(selector);
            if (swiperEl && swiperEl.swiper) {
              swiperEl.swiper.update();
              swiperEl.swiper.slideTo(0, 0);
            }
          });
          
          targetImg.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
      }
    }

    // --- PILL CLICK LISTENER ---
    document.querySelectorAll(".product-form__controls-group label").forEach(function (label) {
      label.addEventListener("click", function () {
        var _this = this;
        var group = _this.closest(".product-form__controls-group");
        
        if (group) {
          group.querySelectorAll("label").forEach(function (sib) { sib.classList.remove("active"); });
          _this.classList.add("active");
        }

        var variantId = _this.getAttribute("data-variant-id");
        var container = _this.closest('.product-section') || document;

        updateAssociatedBlocks(container, variantId);

        // 150ms delay to win the race condition against Shopify's native global.js
        setTimeout(function() {
          var imgUrl = _this.getAttribute("data-variant-image") || _this.getAttribute("data-image-1");
          updateProductGallery(container, imgUrl);
        }, 150);
      });
    });

    // --- DROPDOWN LISTENER ---
    document.querySelectorAll('variant-selects select').forEach(function(select) {
      select.addEventListener('change', function() {
        var container = this.closest('.product-section') || document;
        var wrapper = this.closest('variant-selects');
        var jsonScript = wrapper.querySelector('script[type="application/json"]');
        
        if (jsonScript) {
          try {
            var variants = JSON.parse(jsonScript.textContent);
            var selectedValues = Array.from(wrapper.querySelectorAll('select')).map(function(sel) { return sel.value; });
            
            var matchedVariant = variants.find(function(v) {
              return selectedValues.every(function(val, i) { return v["option" + (i + 1)] === val; });
            });
            
            if (matchedVariant) {
              updateAssociatedBlocks(container, matchedVariant.id.toString());

              if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
                 setTimeout(function() {
                     updateProductGallery(container, matchedVariant.featured_image.src);
                 }, 150);
              }
            }
          } catch (e) {
            console.error("Error parsing variant JSON", e);
          }
        }
      });
    });

    // --- ON PAGE LOAD INIT (legacy swatches) ---
    var checkedInput = document.querySelector(".product-form__controls-group input[type='radio']:checked");
    if (checkedInput) {
      var activeLabel = checkedInput.closest("label");
      if (activeLabel) {
        var container = activeLabel.closest('.product-section') || document;
        var imgUrl = activeLabel.getAttribute("data-variant-image") || activeLabel.getAttribute("data-image-1");
        updateProductGallery(container, imgUrl);
      }
    }

    // --- VARIANT PICKER (<variant-picker>) BRIDGE ---
    // The new picker fires "variant:change" and mirrors the cart form's
    // [name="id"]; here we run the same gallery + associated-block sync the
    // legacy swatches used, looking the variant up by id (+ its gallery image).
    var vpContainer = document.querySelector('.product-section') || document;
    document.addEventListener('variant:change', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      updateAssociatedBlocks(vpContainer, String(id));
      if (e.detail.image) updateProductGallery(vpContainer, e.detail.image);
    });
    // initial sync for the pre-checked variant tile
    var vpChecked = document.querySelector('variant-picker .variant-picker__radio:checked');
    if (vpChecked) {
      updateAssociatedBlocks(vpContainer, String(vpChecked.value));
      if (vpChecked.dataset.image) updateProductGallery(vpContainer, vpChecked.dataset.image);
    }

  }, 500); // 500ms is usually plenty of time for native scripts to load
});
  
    function addToCartAndCheckout(event) {
        event.preventDefault(); // Prevent the default form submission
        const form = event.target.closest('form');
        const formData = new FormData(form);

        // Add the product to the cart
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to add product to cart');
            }
            return response.json();
        })
        .then(() => {
            // Redirect to checkout
            window.location.href = '/checkout';
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
        });
    }

/* ============================================================
   collection grid variant swatches (was collection-swatches.js)
   ============================================================ */
	document.addEventListener("DOMContentLoaded", function() {
		// Preload the new image, then cross-fade the <img> to it — avoids the
		// load flash/pop of a bare src swap. A pure opacity fade carries no
		// motion vector, so it runs even under prefers-reduced-motion.
		function crossfadeSwap(imgEl, newSrc, newAlt) {
			if (!imgEl || !newSrc) return;
			var DUR = 250;

			// Fade the current image out immediately on click. The old logic
			// gated the fade-out on the new image finishing preload, so a slow
			// target left the previous image on screen next to already-updated
			// text. Fading out first decouples the two: the image area clears
			// right away and the new image fades in once it's ready.
			imgEl.style.transition = "opacity " + DUR + "ms ease";
			imgEl.style.opacity = "0";

			// Swap the src while the image is invisible, then fade back in —
			// but only once BOTH the fade-out has elapsed AND the new image has
			// loaded, so we never flash a half-loaded frame.
			var faded = false, loaded = false, swapped = false;
			var swapIn = function() {
				if (swapped || !faded || !loaded) return;
				swapped = true;
				imgEl.src = newSrc;
				if (newAlt != null) imgEl.alt = newAlt;
				requestAnimationFrame(function() {
					requestAnimationFrame(function() { imgEl.style.opacity = "1"; });
				});
			};

			setTimeout(function() { faded = true; swapIn(); }, DUR);

			var pre = new Image();
			pre.onload = pre.onerror = function() { loaded = true; swapIn(); };
			pre.src = newSrc;
			if (pre.complete) { loaded = true; swapIn(); }
		}
		function handleVariantSwitch(label) {
			// A swatch whose only matching variant(s) are sold out is marked
			// aria-disabled in Liquid; never let it arm the card with an
			// unavailable variant (mirrors the product page picker).
			if (label.getAttribute("aria-disabled") === "true" || label.classList.contains("color-swatch--sold-out")) return;

			const wrapper = label.closest(".product-card");
			if (!wrapper) return;

			// --- 1. Add active class to the selected swatch ---
			wrapper.querySelectorAll("label.color-swatch").forEach(function(el) {
				el.classList.remove("active");
			});
			label.classList.add("active");

			// --- 2. Get all data from the clicked swatch ---
			const variantId = label.getAttribute("data-variant-id");
			const variantLink = label.getAttribute("data-variant-link");
			const variantTitle = label.getAttribute("data-variant-title");
			const image1 = (label.getAttribute("data-image-1") || '').trim();
			const image2 = (label.getAttribute("data-image-2") || '').trim();
			const variantPriceMoney = label.getAttribute("data-variant-price-money");
			const variantCompareAtPriceRaw = Number(label.getAttribute("data-variant-compare-at-price-raw"));
			const variantPriceRaw = Number(label.getAttribute("data-variant-price-raw"));
			const variantCompareAtPriceMoney = label.getAttribute("data-variant-compare-at-price-money");

			if (!variantId) return;

			// --- 3. Update hidden inputs and links ---
			const buyNowInput = wrapper.querySelector('.product-form input[name="id"]');
			if (buyNowInput) {
			buyNowInput.value = variantId;
			}
			const productLinks = wrapper.querySelectorAll("a.product-link");
			productLinks.forEach(function(link) {
			if (variantLink) {
				link.setAttribute("href", variantLink);
			}
			});

			// ========================================================================
			// [NEW AND IMPROVED] 4. Update the image container's structure
			// This block replaces the old image update logic entirely.
			// ========================================================================
			const imageContainer = wrapper.querySelector(".product-card__image");
			if (imageContainer) {
				const existingImgs = imageContainer.querySelectorAll('img');

				if (image1 && image2) {
					imageContainer.classList.add("product-card__image--pair");
					if (existingImgs.length >= 2) {
						crossfadeSwap(existingImgs[0], image1, variantTitle || 'Product image');
						crossfadeSwap(existingImgs[1], image2, (variantTitle || 'Product image') + ' reverse');
					} else if (existingImgs.length === 1) {
						crossfadeSwap(existingImgs[0], image1, variantTitle || 'Product image');
						const img2 = new Image(400, 400);
						img2.src = image2;
						img2.alt = (variantTitle || 'Product image') + ' reverse';
						imageContainer.appendChild(img2);
					} else {
						imageContainer.innerHTML = '<img src="' + image1 + '" alt="' + (variantTitle || 'Product image') + '" width="400" height="400"><img src="' + image2 + '" alt="' + (variantTitle || 'Product image') + ' reverse" width="400" height="400">';
					}
				} else {
					imageContainer.classList.remove("product-card__image--pair");
					const displaySrc = image1 || image2;
					const displayAlt = image1
						? (variantTitle || 'Product image')
						: (variantTitle || 'Product image') + ' reverse';
					if (displaySrc) {
						imageContainer.innerHTML = '<img src="' + displaySrc + '" alt="' + displayAlt + '" width="400" height="400">';
					}
				}
			}

			// --- 5. Update the price display ---
			const priceContainer = wrapper.querySelector("p.price");
			if (priceContainer && variantPriceMoney) {
				let newPriceHTML = '';
				if (variantCompareAtPriceRaw > variantPriceRaw) {
					newPriceHTML = `<span class="current-price">${variantPriceMoney}</span> <span class="old-price">${variantCompareAtPriceMoney}</span>`;
				} else {
					newPriceHTML = `<span class="price">${variantPriceMoney}</span>`;
				}
				priceContainer.innerHTML = newPriceHTML;
			}

			// --- 6. Update the variant name ---
			const tonedElement = wrapper.querySelector("p.product-card__variant-name");
			if (tonedElement && variantTitle) {
			const titleParts = variantTitle.split('/');
			tonedElement.textContent = titleParts[0].trim();
			}

			// --- 7. Update the 'ADD TO BAG' button's data-product-url ---
			const addToBagButton = wrapper.querySelector('.quick-add button[name="add"]');
			if (addToBagButton && variantLink) {
				addToBagButton.setAttribute('data-product-url', variantLink);
			}
			
			// --- 8. Set the variant ID on the main card wrapper for the custom Add to Bag script ---
			wrapper.setAttribute('data-variant-id', variantId);
		}

		// Attach click listeners to all thumbnail-strip swatches, on every
		// surface that renders them (collection grid, search, popular products,
		// predictive search). Delegated from document so dynamically loaded
		// cards are covered.
		// Prevent the swatch from stealing focus on mousedown: inside the
		// predictive-search overlay, focus leaving the search field triggers a
		// focusout-close that would dismiss the overlay before the swap is seen.
		document.addEventListener('mousedown', function (e) {
			var label = e.target.closest('.product-card--thumbs label.color-swatch');
			if (!label) return;
			e.preventDefault();
		});
		document.addEventListener('click', function (e) {
			var label = e.target.closest('.product-card--thumbs label.color-swatch');
			if (!label) return;
			handleVariantSwitch(label);
		});
	});

/* ===== consolidated from customer.js — account addresses ===== */
(function () {
const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  expandedTarget: 'data-expand',
  confirmMessage: 'data-confirm-message',
  id: 'data-id'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target, items) {
    if (items === undefined) items = false;

    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );

    if (target.getAttribute('data-type') === 'reset') { // Cancel buttons
      const item = target.closest('.js-expand-elem');
      const empty = document.querySelector('.account-none-address');

      item.closest('.js-expand-elem').setAttribute(
        attributes.expandedTarget,
        (item.closest('.js-expand-elem').getAttribute(attributes.expandedTarget) === 'false').toString()
      )

      if (empty) {
        empty.setAttribute(
          attributes.expandedTarget,
          (item.getAttribute(attributes.expandedTarget) === 'false').toString()
        )
      }
    } else if (target.getAttribute('data-type') === 'new') {
      const item = document.getElementById('AddAddress');
      const empty = document.querySelector('.account-none-address');

      if (item.getAttribute(attributes.expandedTarget) === 'false') {
        setTimeout(function () {
          var a = document.getElementById('AddAddress'); if (a) window.scrollTo({ top: a.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
        }, 100);
      }

      item.setAttribute(
        attributes.expandedTarget,
        (item.getAttribute(attributes.expandedTarget) === 'false').toString()
      )

      if (empty) {
        empty.setAttribute(
          attributes.expandedTarget,
          (item.getAttribute(attributes.expandedTarget) === 'false').toString()
        )
      }
    } else { // Edit address buttons
      items.forEach(el => {
        if (target.getAttribute('id').slice(15) === el.getAttribute('id').slice(12)) {
          el.setAttribute(
            attributes.expandedTarget,
            (el.getAttribute(attributes.expandedTarget) === 'false').toString()
          )
        }

        if (el.getAttribute(attributes.expandedTarget) === 'false') {
          setTimeout(function () {
            var p = target.closest('.address-list__item').previousElementSibling; if (p) window.scrollTo({ top: p.offsetTop, behavior: 'smooth' });
          }, 100);
        }
      })
    }
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget,
      currentTarget.closest('.addresses').querySelectorAll('.js-expand-elem')
    );
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
    );
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}

  window.addEventListener('load', function () { new CustomerAddresses(); });
})();

/* ===== consolidated from input.js — country-select placeholder on address forms ===== */
window.addEventListener('load', function () {
  document.querySelectorAll('.js-select').forEach(function (wrap) {
    var firstOption = wrap.querySelector('option');
    if (firstOption) firstOption.remove();

    var ph = document.createElement('div');
    ph.className = 'placeholder-select';
    ph.innerHTML = 'Country <span>*</span>';
    wrap.prepend(ph);

    var select = wrap.querySelector('select');
    if (!select) return;
    var defOption = document.createElement('option');
    defOption.value = 'Country';
    defOption.setAttribute('data-provinces', '[]');
    defOption.selected = true;
    defOption.disabled = true;
    select.prepend(defOption);

    select.addEventListener('change', function () {
      select.style.color = 'rgb(var(--color-base-text), 1)';
      var phEl = wrap.querySelector('.placeholder-select');
      if (phEl) phEl.remove();
    });
  });
});

/* ===== consolidated from newsletter.js — countdown timer ===== */
(function () {
  function fadeIn(el) {
    if (getComputedStyle(el).display !== 'none') return; // already shown -> no-op (don't restart the fade)
    el.style.opacity = '0';
    el.style.display = 'block';
    el.getBoundingClientRect(); // force reflow
    el.style.transition = 'opacity 0.4s';
    el.style.opacity = '1';
  }

  function initTimer() {
    document.querySelectorAll('.js-countdown').forEach(function (el) {
      var completedCountdown = el.dataset.completed;
      var countdown = el.querySelector('.newsletter__timer');
      var countdownHeading = el.querySelector('.countdown__heading');
      var daysEl = el.querySelector('.date__days');
      var hoursEl = el.querySelector('.date__hours');
      var minutesEl = el.querySelector('.date__mins');
      var secondsEl = el.querySelector('.date__secs');
      var section = el.closest('.shopify-section');

      var countdownDate = new Date(el.dataset.date + 'T' + el.dataset.time);
      var distance = countdownDate.getTime() - new Date().getTime();
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0 && completedCountdown === 'hide_section') {
        if (section) section.style.display = 'none';
      } else if (distance < 0 && completedCountdown === 'show_text') {
        if (countdown) countdown.style.display = 'none';
        if (countdownHeading) fadeIn(countdownHeading);
      } else {
        if (daysEl) daysEl.innerHTML = days < 10 ? '0' + days : days;
        if (hoursEl) hoursEl.innerHTML = hours < 10 ? '0' + hours : hours;
        if (minutesEl) minutesEl.innerHTML = minutes < 10 ? '0' + minutes : minutes;
        if (secondsEl) secondsEl.innerHTML = seconds < 10 ? '0' + seconds : seconds;
      }
    });
  }

  function start() {
    if (!document.hidden && document.querySelector('.js-countdown')) setInterval(initTimer, 1000);
  }
  document.addEventListener('shopify:section:load', start);
  start();
})();

/* ===== consolidated from load-more.js — load-more / infinite scroll ===== */
(function () {
  function loadItems(button) {
    var totalPages = parseInt(document.querySelector('[data-total-pages]').value);
    var currentPage = parseInt(document.querySelector('[data-current-page]').value);
    var currentPageScroll = currentPage + 1;
    currentPage = currentPage + 1;
    var nextUrlInput = document.querySelector('[data-next-url]');
    var nextUrl = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + currentPage);
    var nextUrlScroll = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + currentPageScroll);
    document.querySelectorAll('[data-current-page]').forEach(function (el) { el.value = currentPage; });

    button.setAttribute('disabled', '');
    button.classList.add('loading');

    fetch(nextUrl)
      .then(function (r) { return r.text(); })
      .then(function (responseHTML) {
        var doc = new DOMParser().parseFromString(responseHTML, 'text/html');
        var responseGrid = doc.querySelector('.load-more-grid');
        var newItems = responseGrid
          ? Array.prototype.filter.call(responseGrid.children, function (c) {
              return !c.classList.contains('dom_insertion_exclusion');
            })
          : [];
        if (!newItems.length) {
          document.querySelectorAll('.dom_insertion_exclusion').forEach(function (e) { e.remove(); });
          return;
        }
        var loaderElement = document.querySelector('.load-more-grid .dom_insertion_exclusion');
        if (loaderElement) {
          newItems.forEach(function (item) { loaderElement.parentNode.insertBefore(item, loaderElement); });
        } else {
          var grid = document.querySelector('.load-more-grid');
          if (grid) newItems.forEach(function (item) { grid.appendChild(item); });
        }
      })
      .catch(function () {})
      .finally(function () {
        if (currentPage <= totalPages) {
          var scollData = document.querySelector('.infinite-scroll__data');
          if (scollData && currentPage != totalPages) {
            scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
            scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
            scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
            scollData.querySelector('input[data-current-page]').value = currentPage;
            checkVisibility();
          }
          button.removeAttribute('disabled');
          button.classList.remove('loading');
          if (currentPage == totalPages) {
            button.remove();
          }
        }
      });
  }

  function checkVisibility() {
    document.querySelectorAll('.js-infinite-scroll').forEach(function (spinner) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        });
      });
      sectionObserver.observe(spinner);
    });
  }

  function loadMore() {
    document.querySelectorAll('.js-load-more').forEach(function (button) {
      button.onclick = function () { loadItems(button); };
    });
    checkVisibility();
  }

  loadMore();
})();

/* ===== consolidated from section-image-tabs.js — image tabs (Swiper) ===== */
(function () {
  function imageTabs() {
    document.querySelectorAll('.js-image-tabs').forEach(function (parent) {
      var parentId = '#' + parent.id;
      var params = document.querySelector(parentId).querySelector('.js-img-slide');
      var swiperImage = parentId + ' .js-img-slide';
      var swiperDescription = parentId + ' .js-description-slide';
      var jsTabs = parentId + ' .js-tabs';
      var pagination = parentId + ' .swiper-pagination';
      var effects = params.dataset.effects;

      function slideEffectsTabs(fx) {
        switch (fx) {
          case 'slide-horizontal': return {};
          case 'slide-vertical': return { direction: 'vertical' };
          case 'fade': return { effect: 'fade', parallax: false };
          case 'coverflow': return { effect: 'coverflow', coverflowEffect: { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: true } };
          case 'creative': return { effect: 'creative', creativeEffect: { prev: { shadow: true, translate: [0, 0, -400] }, next: { translate: ['100%', 0, 0] } } };
          case 'flip': return { effect: 'flip' };
          default: return {};
        }
      }

      function applyThemeMode() {
        var active = document.querySelector('.swiper-slide-active');
        var isDark = active ? active.classList.contains('block-theme-mode-dark') : false;
        document.querySelectorAll('.js-theme-mode').forEach(function (el) {
          el.classList.toggle('section-theme-mode-dark', isDark);
          el.classList.toggle('section-theme-mode-light', !isDark);
        });
      }

      var imageTabsSwiper = new Swiper(swiperImage, Object.assign(
        { speed: 1000 },
        slideEffectsTabs(effects),
        {
          allowTouchMove: false,
          pagination: { el: pagination, clickable: true },
          on: { init: applyThemeMode, transitionStart: applyThemeMode }
        }
      ));

      var descriptionTabsSwiper = new Swiper(swiperDescription, {
        allowTouchMove: false,
        spaceBetween: 30,
        1200: { spaceBetween: 0 }
      });
      imageTabsSwiper.controller.control = descriptionTabsSwiper;
      descriptionTabsSwiper.controller.control = imageTabsSwiper;

      document.querySelectorAll(jsTabs + ' .tabs__item').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          var thisIndex = Array.prototype.indexOf.call(this.parentNode.children, this);
          var currentEl = document.querySelector(jsTabs + ' .tabs__item--current');
          var currentIndex = currentEl ? Array.prototype.indexOf.call(currentEl.parentNode.children, currentEl) : -1;
          if (thisIndex !== currentIndex) {
            this.classList.add('tabs__item--current');
            var allTabs = document.querySelectorAll('.tabs__item');
            if (allTabs[currentIndex]) allTabs[currentIndex].classList.remove('tabs__item--current');
            var paginationEl = document.querySelector(pagination);
            var bullets = paginationEl ? paginationEl.querySelectorAll('.swiper-pagination-bullet') : [];
            if (bullets[thisIndex]) bullets[thisIndex].click();
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    imageTabs();
    document.addEventListener('shopify:section:load', function () { imageTabs(); });
  });
})();
